<template>
  <v-select
    v-model="selectValue"
    :items="items"
    hide-details
    class="mt-0 pt-0"
  >
    <template #item="{ item }">
      <CommonChip class="mr-2">{{ item.text }}:</CommonChip>
      <span>{{ item.value }}</span>
    </template>
    <template #selection="{ item }">
      <CommonChip class="mr-2">{{ item.text }}:</CommonChip>
      <span>{{ item.value }}</span>
    </template>
  </v-select>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';

import { ITextValue } from '@/types/common';

import CommonChip from '@/bundles/Common/components/chips/CommonChip.vue';

export default Vue.extend({
  name: 'VCardImportSelect',

  components: { CommonChip },

  props: {
    value: {
      type: String,
      default: ''
    },
    items: {
      type: Array as PropType<ITextValue<string>[]>,
      default: () => []
    }
  },

  computed: {
    selectValue: {
      get (): string {
        return this.value;
      },
      set (value: string) {
        this.$emit('input', value);
      }
    },
  }
})
</script>
